import { Box, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import IconButton from "./IconButton";
import {
  Delete,
  Download,
  Edit,
  Visibility,
  NoteAdd,
  MoreTime,
  Room,
  FileUpload,
  AdminPanelSettings,
} from "@mui/icons-material";

interface Props {
  id: number;
  handleEdit?: (id: number) => void;
  handleView?: (id: number) => void;
  handleDelete?: (id: number) => void;
  handleDownload?: (id: number) => void;
  handleAddNote?: (id: number) => void;
  handleAddHours?: (id: number) => void;
  handleAddressRoute?: () => void;
  handleUpload?: () => void;
  handleAdminRoute?: (id: number) => void;
  highPriority?: boolean;
}

const TableActions: React.FC<Props> = (props) => {
  const {
    id,
    handleEdit,
    handleView,
    handleDelete,
    handleDownload,
    handleAddNote,
    handleAddHours,
    handleAddressRoute,
    handleUpload,
    highPriority,
    handleAdminRoute,
  } = props;
  const theme = useTheme();

  const xs = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        color:
          highPriority && !xs
            ? theme.palette.primary.contrastText
            : theme.palette.primary.main,
      }}
      component={"span"}
    >
      {!!handleEdit && (
        <IconButton
          label="Edit"
          onClick={() => handleEdit(id)}
          icon={<Edit fontSize={xs ? "large" : "small"} color="primary" />}
        />
      )}

      {!!handleView && (
        <IconButton
          label="View"
          onClick={() => handleView(id)}
          icon={
            <Visibility fontSize={xs ? "large" : "small"} color="primary" />
          }
        />
      )}

      {!!handleAddNote && (
        <IconButton
          label="Add Note"
          onClick={() => handleAddNote(id)}
          icon={<NoteAdd fontSize={xs ? "large" : "small"} color="primary" />}
        />
      )}

      {!!handleAddHours && (
        <IconButton
          label="Add Hours"
          onClick={() => handleAddHours(id)}
          icon={<MoreTime fontSize={xs ? "large" : "small"} color="primary" />}
        />
      )}
      {!!handleAddressRoute && (
        <IconButton
          label="View Sites"
          onClick={handleAddressRoute}
          icon={<Room fontSize={xs ? "large" : "small"} color="primary" />}
        />
      )}
      {!!handleDownload && (
        <IconButton
          label="Download"
          onClick={() => handleDownload(id)}
          icon={<Download fontSize={xs ? "large" : "small"} color="primary" />}
        />
      )}
      {!!handleUpload && (
        <IconButton
          label="Upload File"
          onClick={handleUpload}
          icon={
            <FileUpload fontSize={xs ? "large" : "small"} color="primary" />
          }
        />
      )}
      {!!handleDelete && (
        <IconButton
          label="Delete"
          onClick={() => handleDelete(id)}
          icon={<Delete fontSize={xs ? "large" : "small"} color="primary" />}
        />
      )}
      {!!handleAdminRoute && (
        <IconButton
          onClick={() => handleAdminRoute(id)}
          label="Edit in Admin"
          icon={
            <AdminPanelSettings fontSize={"small"} aria-label="admin-button" />
          }
        />
      )}
    </Box>
  );
};

export default TableActions;
